<template>
  <div
    v-if="rating"
    class="sticker"
  >
    <component
      :is="`defaqto-rating${rating}`"
    />
  </div>
</template>

<script>
import DefaqtoRating1 from '@/components/DefaqtoIcons/DefaqtoRating1';
import DefaqtoRating2 from '@/components/DefaqtoIcons/DefaqtoRating2';
import DefaqtoRating3 from '@/components/DefaqtoIcons/DefaqtoRating3';
import DefaqtoRating4 from '@/components/DefaqtoIcons/DefaqtoRating4';
import DefaqtoRating5 from '@/components/DefaqtoIcons/DefaqtoRating5';

export default {
  name: 'defaqto-sticker',
  components: {
    DefaqtoRating1,
    DefaqtoRating2,
    DefaqtoRating3,
    DefaqtoRating4,
    DefaqtoRating5,
  },
  props: {
    rating: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
  .sticker {
    width: 100%;
  }
</style>
